const normalizeCode = (value: unknown): string =>
  typeof value === 'string' ? value.toLowerCase() : '';

const normalizeMessage = (value: unknown): string => {
  if (typeof value !== 'string') {
    return '';
  }

  return value
    .replace(/^firebaseerror:\s*/i, '')
    .replace(/^functions\/[a-z-]+:\s*/i, '')
    .trim();
};

const getBackendMessage = (error: unknown): string => {
  const candidate = error as {
    message?: unknown;
    details?: unknown;
  };

  return normalizeMessage(candidate?.details) || normalizeMessage(candidate?.message);
};

export const getSuggestionActionErrorMessage = (error: unknown): string => {
  const candidate = error as {
    code?: unknown;
  };
  const code = normalizeCode(candidate?.code);
  const backendMessage = getBackendMessage(error);

  if (code.includes('permission-denied')) {
    return backendMessage
      ? `Backend odmówił uprawnień: ${backendMessage}`
      : 'Backend odmówił uprawnień do wykonania tej akcji.';
  }

  if (code.includes('invalid-argument')) {
    return backendMessage
      ? `Backend odrzucił dane akcji: ${backendMessage}`
      : 'Backend odrzucił dane akcji jako nieprawidłowe.';
  }

  if (code.includes('not-found')) {
    return backendMessage
      ? `Backend nie znalazł rekordu: ${backendMessage}`
      : 'Backend nie znalazł wskazanej sugestii.';
  }

  if (code.includes('failed-precondition')) {
    return backendMessage
      ? `Warunek backendu nie został spełniony: ${backendMessage}`
      : 'Warunek backendu nie został spełniony dla bieżącego stanu sugestii.';
  }

  return backendMessage || 'Nie udało się wykonać akcji dla sugestii.';
};
